import { render, staticRenderFns } from "./GlobalSearchMultipleResultFooter.vue?vue&type=template&id=7666dbdc&"
import script from "./GlobalSearchMultipleResultFooter.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchMultipleResultFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports